import { PlainDocument, preload } from '../../../layouts/plain-document';
import type { RouteDefinition } from '@solidjs/router';

export default function TermsOfService() {
	return <PlainDocument slug="course-access-terms-and-conditions" />;
}

export const route = { preload: preload('course-access-terms-and-conditions') } satisfies RouteDefinition;
